import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight, ArrowLeft, Dumbbell, Apple, Snowflake, MessageSquare, Activity, RefreshCw, Check } from 'lucide-react';
import { motion } from 'framer-motion';

const items = [
  { icon: Dumbbell, title: 'Personalized Training Programs', color: '#00C8FF' },
  { icon: Apple, title: 'Flexible Nutrition System', color: '#65A30D' },
  { icon: Snowflake, title: 'Recovery Protocols', color: '#7DD3FC' },
  { icon: MessageSquare, title: 'Direct Coach Support', color: '#FFB800' },
  { icon: Activity, title: 'Progress Tracking & YourReGen Score', color: '#FF6FA8' },
  { icon: RefreshCw, title: 'Ongoing Program Adjustments', color: '#00C8FF' },
];

const credentials = [
  'Former Professional Athlete',
  '30+ Years Coaching Experience',
  'Coach · Nutritionist · Biohacker',
];

export default function Receive() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen flex flex-col px-6 pt-12 pb-10 max-w-2xl mx-auto">
      <button data-testid="back-btn" onClick={() => nav(-1)} className="text-muted-foreground hover:text-foreground inline-flex items-center gap-2 text-sm"><ArrowLeft className="w-4 h-4" /> Back</button>
      <div className="mt-8">
        <div className="label-mini text-[var(--c-green-ink)]">Inside Your Program</div>
        <h1 className="font-display font-black text-4xl md:text-5xl mt-3 tracking-tight">What You'll Receive</h1>
        <p className="text-muted-foreground mt-3">Built for you. Adjusted as you progress.</p>
      </div>

      <div className="mt-8 space-y-3">
        {items.map((t, i) => (
          <motion.div key={i} initial={{ opacity: 0, x: -12 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.06 }} data-testid={`receive-item-${i}`} className="regen-card-elevated p-4 flex items-center gap-4">
            <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ background: `${t.color}1a` }}>
              <t.icon className="w-5 h-5" style={{ color: t.color }} strokeWidth={2.2} />
            </div>
            <div className="font-medium flex-1">{t.title}</div>
          </motion.div>
        ))}
      </div>

      {/* Premium credibility card */}
      <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }} className="mt-6 regen-card-elevated p-5 blueprint-grid relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#00C8FF]/10 rounded-full blur-3xl -translate-y-12 translate-x-12" />
        <div className="relative">
          <div className="label-mini text-[#00C8FF]">Built by</div>
          <div className="font-display font-black text-3xl mt-1 italic">Coach JP</div>
          <div className="mt-4 space-y-2">
            {credentials.map((c, i) => (
              <div key={i} className="flex items-center gap-2.5 text-sm">
                <div className="w-5 h-5 rounded-full bg-[var(--c-green-soft)] border border-[var(--c-green-soft)] flex items-center justify-center flex-shrink-0">
                  <Check className="w-3 h-3 text-[var(--c-green-ink)]" strokeWidth={3} />
                </div>
                <span className="text-foreground">{c}</span>
              </div>
            ))}
          </div>
        </div>
      </motion.div>

      <Button onClick={() => nav('/onboarding/nutrition')} data-testid="continue-receive-btn" className="mt-8 h-14 w-full bg-[#00C8FF] hover:bg-[#00C8FF]/90 text-[#081726] font-semibold rounded-2xl">
        Continue <ArrowRight className="ml-2 w-4 h-4" />
      </Button>
    </div>
  );
}
